import { render } from "./ResetPasswordView.vue?vue&type=template&id=1427454c&scoped=true"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js"

import "./ResetPasswordView.vue?vue&type=style&index=0&id=1427454c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1427454c"]])

export default __exports__